import { FormColumn, Typography } from "best-common-react";
import React from "react";
import {
  DefaultUIConfig,
  UITheme,
  VenueUIConfig,
  VenueUIConfigOptions,
  VenueUIConfigOptionsKeys,
} from "../../types/Config";
import ConfigForm from "./ConfigForm";

type SliderConfigProps = {
  config: VenueUIConfig;
  onChange: (key: VenueUIConfigOptionsKeys, value: UITheme | string | number | boolean) => void;
  pitchersView?: string;
};

const SliderConfig: React.FC<SliderConfigProps> = ({ config, onChange, pitchersView }) => {
  const uiConfig: VenueUIConfigOptions | undefined = !!config?.strikeZoneConfig
    ? (config.strikeZoneConfig as VenueUIConfigOptions)
    : DefaultUIConfig;

  return (
    <div className="row">
      <FormColumn width={1}>
        <Typography variant="h5">SLIDER Configuration</Typography>
      </FormColumn>
      <FormColumn width={1}>
        <ConfigForm uiConfig={uiConfig} onChange={onChange} pitchersView={pitchersView} isThin={false} />
      </FormColumn>
    </div>
  );
};

export default SliderConfig;
